import React from "react";
import { Box, Container } from "@mui/material";
import Topbar from "./Topbar";

interface LayoutProps {
    children: React.ReactNode;
    isLoggedIn: boolean;
    isAdmin?: boolean;
    onLogout?: () => void;
}

const Layout: React.FC<LayoutProps> = ({ children, isLoggedIn, isAdmin, onLogout }) => {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", width: "100%" }}>
            {isLoggedIn && <Topbar isLoggedIn={isLoggedIn} isAdmin={isAdmin} onLogout={onLogout} />}
            <Container component="main"
                sx={{
                    flexGrow: 1,
                    mt: 8,
                    mb: 2,
                    backgroundColor: (theme) => theme.palette.background.default,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center", // optional, for horizontal centering
                    minHeight: "calc(100vh - 64px - 32px)", // adjust for topbar/footer if needed
                }}>
                {children}
            </Container>
            {isLoggedIn && <Box
                component="footer"
                position={"fixed"}
                sx={{
                    py: 1,
                    px: 2,
                    mt: "auto",
                    backgroundColor: (theme) => theme.palette.background.paper,
                    bottom: 0,
                    width: "100%",
                    textAlign: "center",
                    color: (theme) => theme.palette.text.secondary,
                }}
            >
                <Container maxWidth="sm">
                    <Box sx={{ textAlign: "center" }}>
                        © {new Date().getFullYear()} ThoughtDesk. All rights reserved.
                    </Box>
                </Container>
            </Box>}
        </Box>
    );
};

export default Layout;